export default __webpack_public_path__ + "static/media/Path3400.396bb2a6.svg";